<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header p-2">
              <h6 class="modal-title">
                <template v-if="newFav">Save as</template>
                <template v-else>{{$t('Rename')}} {{ favInfo.type.toLowerCase() }}</template>
              </h6>
              <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                <span aria-hidden="true">
                    <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                    </cancel-icon>
                </span>
              </button>
            </div>
            <div class="modal-body">
              <input @keyup.enter="updateFavName()" type="text" class="bg-transparent border rounded text-light form-control input-fields"
               v-model="favName" ref="fieldEditCatalog">
            </div>
            <div class="modal-footer p-0 primary-btn-style">
              <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click.prevent="closeDialog()">{{$t('Cancel')}}</button>
              <button class="btn btn-outline-primary" @click.prevent="updateFavName()">
                <template v-if="newFav">{{$t('Save')}}</template>
                <template v-else>{{$t('Rename')}}</template></button>
            </div>
          </div>
        </div>
      </div>
</template>
    
    
<script>
    import {mapActions} from "vuex";
    import cancelIcon from "../core/InlineCancelField.vue"
    
    
    export default {
      props:["favInfo", "newFav"],
      data: () => ({
        dialog: true,
        favName:""
      }),
      methods:{
          closeDialog(){
              this.$emit("close")
          },
          components:{
            'cancel-icon':cancelIcon
          },
          updateFavName(){
            this.favName = this.favName.trim()
            if(this.newFav){
              // let routeQuery = this.$route.query
              // if(routeQuery && 'advanceFilter' in routeQuery && routeQuery.advanceFilter){
              //   let searchQuery = routeQuery.advanceFilter

              // }else {
              //   alert("Empty search query is not allowed to save.")
              // }
              if (this.favName.length != 0){
                if(this.favName.includes(",")){
                  alert("Name with commma(,) is not allowed");
                  return false;
                }
                if(this.favInfo.type == "Saved Search"){
                    this.$emit("validateSearchQuery")
                    return
                }
                let payload = {name: this.favName, url: this.$route.fullPath, type:this.favInfo.type}
                this.addNewFavorite(payload).then((data)=>{
                  if (data.statusCode==200){
                    this.$toast.success(`${payload.type} "${payload.name}" created successfully.`);
                    this.closeDialog()
                  }else{
                    if('message' in data){
                      alert(this.getReadbleMessage(data.message))
                    }else{
                      this.$toast.error(`Failed to create ${payload.type} "${payload.name}".`);
                    }
                  }
                })
              }else{
                alert("Please add valid name.")
              }
            }
            else{
              if (this.favName.length != 0){
                if(this.favName.includes(",")){
                  alert("Name with commma(,) is not allowed");
                  return false;
                }
                let payload = {_id: this.favInfo._id, name: this.favName, params:{_id:this.favInfo._id}}
                this.updateExistingFavorite(payload).then((data)=>{
                  if (data.statusCode==200){
                    this.$toast.success(`${this.favInfo.type} "${this.favName}" updated successfully.`);
                    this.closeDialog()
                  }else{
                    if('message' in data){
                      alert(this.getReadbleMessage(data.message))
                    }else{
                      this.$toast.error(`Failed to update ${this.favInfo.type} "${this.favName}"`);
                    }
                  }
                })
              }else{
                alert("Please add valid name.")
              }
            }
          },
          validatedQuery(queryDetails){
            let fullPath = this.$route.path
            if(queryDetails){
              let qString = ""
              if('keyword' in queryDetails){
                qString = `keyword=${queryDetails['keyword']}`
              }
              if('advanceFilter' in queryDetails){
                if(qString.trim().length){
                  qString += "&"
                }
                qString += "advanceFilter="+JSON.stringify(queryDetails['advanceFilter'])
              }

              if(qString.trim().length){
                fullPath += "?"+ qString
              }
            }
            let payload = {name: this.favName, url: fullPath, type:this.favInfo.type}
            this.addNewFavorite(payload).then((data)=>{
              if (data.statusCode==200){
                this.$toast.success(`${payload.type} "${payload.name}" created successfully.`);
                this.closeDialog()
              }else{
                if('message' in data){
                  alert(this.getReadbleMessage(data.message))
                }else{
                  this.$toast.error(`Failed to create ${payload.type} "${payload.name}".`);
                }
              }
            })
          },
          getReadbleMessage(valueErrorMessage){
            let stringToRemove = "'name'"
            if(valueErrorMessage.startsWith(stringToRemove)){
              const index = valueErrorMessage.indexOf(stringToRemove);
              if (index !== -1) {
                const modifiedString = valueErrorMessage.slice(0, index) + valueErrorMessage.slice(index + stringToRemove.length + 1);
                return modifiedString;
              }
            }
            return valueErrorMessage
          },
        ...mapActions("favorites", ["updateExistingFavorite","addNewFavorite"]),
      },
      created(){
        this.favName = this.favInfo.name
      },
      mounted(){
        this.$refs.fieldEditCatalog.focus();
      }
    }
    </script>
    
    <style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    .modal-dialog {
        max-width: 600px;
        width: 600px;
        margin: 0;
        padding: 0;
      }
      
      .modal-content {
        height: 227px;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          padding: 2rem;
        }
      }
    
    .modal {
      text-align: center;
      padding: 0!important;
      display:block;
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    .modal:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-inline-end: -4px;
    }
    .modal-dialog {
      display: inline-block;
      text-align: start;
      vertical-align: middle;
    }
    .modal:before {
      content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        .modal-title{
          color:$text-color;
        }
    }
    
    .primary-btn-style{
        margin-top:1%;
        button{
            height: 35px;
            width: 70px;
            font-size:14px;
        }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }
    
    .key-style {
      color: $dull-text-color;
      width: 30%;
      text-align: start;
      font-size: $input-field-and-label-font-size;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    
    .input-fields {
      border: none !important;
      border-bottom: 1px solid $active-blue !important;
      height:30px;
    }
    
    .input-fields:focus {
      outline: unset;
      box-shadow:none;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .config-desc{
      color: $dull-text-color;
      font-size:12px;
    }
    </style>